export class EnumNameValue {
    name = '';
    value = 0;

    public constructor(entity: any) {
        if (entity) {
            this.name = entity.name;
            this.value = entity.value;
        }
    }
}
